export default __webpack_public_path__ + "e8a16518daef6e13f7f666000759cca6.svg";